import { onCleanup } from 'solid-js';
import {
  addPauseListener,
  addPlayingListener,
  addPlayListener,
  goLive,
} from '~/cast/lib';

export function useGoLiveOnLongPause(
  longPauseMinutes: () => number,
  isLive: () => boolean,
) {
  let pauseTime: ReturnType<typeof Date.now> | undefined;

  const removePlayListener = addPlayListener(() => {
    if (
      isLive() &&
      pauseTime !== undefined &&
      Date.now() - pauseTime > longPauseMinutes() * 60 * 1000
    ) {
      goLive();
    }
  });

  const removePlayingListener = addPlayingListener(() => {
    pauseTime = undefined;
  });

  const removePauseListener = addPauseListener(() => {
    pauseTime = Date.now();
  });

  onCleanup(() => {
    removePlayListener();
    removePlayingListener();
    removePauseListener();
  });
}
